export const MAIN_HEADER = ["Best place to buy", "battery rickshaw", ""];

export const CHOOSE_ELECTRIC_AUTO_HEADER = [
  "Choose",
  "electric autos",
  "from top brands",
];

export const LEAD_GENERATION_HEADER_TEXT = "Buy e rickshaw from Turno";

export const LEAD_GENERATION_BUTTON_TEXT = "Get on-road price";

export const CARGO_EV_TURO_TABLE_DATA = [
  "Cheaper to operate",
  "Cheaper to maintain",
  "Fewer moving parts",
  "No oil changes",
  "Instant torque",
  "More responsive",
  "Govt. benefits",
  "More reliable",
  "Fewer breakdowns",
  "Latest technology",
  "Advance safety features",
  "Future of transportation",
  "Growing network of charging stations",
  "Charging at home",
];

export const CNG_CARGO_TABLE_DATA = [
  "Expensive to operate",
  "High-priced  maintenance",
  "More moving parts",
  "Frequent oil changes",
  "No instant torque",
  "Less responsive",
  "No govt. benefits",
  "Not reliable",
  "Frequent breakdowns",
  "Old-age technology",
  "No advanced safety features",
  "Govt. may ban it soon",
  "Limited CNG gas stations",
  "Long lines at fuel stations",
];

export const DISCOVER_RANGE_HEADER =
  "Discover the range of passenger battery rickshaws @ Turno";

export const DISCOVER_RANGE_SUBHEADER =
  "Multiply your earnings easily by switching to battery auto rickshaws. Enjoy the enhanced power and performance of e rickshaws while saving 90% of fuel expense. Charge at home or public charging stations and drive as long as 180 km on a single charge. Choose from the wide range of battery rickshaws from Turno.";

export const DISCOVER_RANGE_LIST = [];

export const REVIEW_CARDS_HEADER = "Happy Customers";

export const REVIEW_CARDS_CONTENT = [
  {
    name: "Neeraj Pandey",
    owner_of: "",
    review_point: "Excellent services by Turno",
    stars: 5,
    image_url:
      "https://assets.turnoclub.com/developer/offer-turno-images/S3/WhyTurno/electric-passenger/Customer+Photos_hindi-01.webp",
    review_descriptions:
      "No one in the market gives EV loans as quickly as Turno gives. Thank you, Turno.",
  },
  {
    name: "Faruq Abdulla",
    owner_of: "",
    review_point: "Excellent services by Turno",
    stars: 4,
    image_url:
      "https://assets.turnoclub.com/developer/offer-turno-images/S3/WhyTurno/electric-passenger/Customer+Photos_hindi-02.webp",
    review_descriptions:
      "With Turno, I got my passenger rickshaw in just 1 day.",
  },
  {
    name: "Rajat Singh",
    owner_of: "",
    review_point: "Turno expert guided me well",
    stars: 5,
    image_url:
      "https://assets.turnoclub.com/developer/offer-turno-images/S3/WhyTurno/ElectricCommercialGoodsIcons/Customer+Photos-03.webp",
    review_descriptions:
      "My loan processing was very smooth. Turno representatives come to my home for the documentation.",
  },
];

export const TABLE_MAIN_HEADER_CONTENT = " Buy Battery Auto";
export const TABLE_MAIN_SUB_HEADER_CONTENT =
  " Increase Your Earnings Effortlessly";

export const TABLE_SUB_HEADER_CONTENT = [
  {
    title: "Passenger EVs from Turno",
    image_url:
      "https://assets.turnoclub.com/developer/offer-turno-images/S3/WhyTurno/electric-passenger/passenger-02.webp",
  },
  {
    title: "CNG Passenger Auto",
    image_url:
      "https://assets.turnoclub.com/developer/offer-turno-images/S3/WhyTurno/electric-passenger/passenger-01.webp",
  },
];

export const WHY_TURNO_HEADER = "Why Turno?";

export const WHY_TURNO_SUB_TEXT =
  "Turno is your end-to-end partner when it comes to choosing and buying your 3W passenger electric vehicle.";

export const WHY_TURNO_DATA = [
  {
    image_url: "",
    header: "Assured Financing",
    content: "Get a 100% guaranteed EV loan with a low down payment.",
  },
  {
    image_url: "",
    header: "Assured Buyback",
    content: "Get up to ₹1.5L after 3 years.",
  },
  {
    image_url: "",
    header: "2-day Delivery",
    content:
      "Get the fastest delivery ever.",
  },
  {
    image_url: "",
    header: "E.M.I. Starting From ₹11,000",
    content:
      "Take home EV in easy installements.",
  },
];

export const CONNECT_WITH_US_HEADER =
  "Still thinking? Talk to our EV Experts now";

export const CONNECT_WITH_US_CTA_INGO = "Get a callback";

export const ICON_IMAGE_01 =
  "https://assets.turnoclub.com/developer/offer-turno-images/S3/WhyTurno/ElectricCommercialGoodsIcons/icon-01.webp";
export const ICON_IMAGE_02 =
  "https://assets.turnoclub.com/developer/offer-turno-images/S3/WhyTurno/ElectricCommercialGoodsIcons/icon-03.webp";
export const ICON_IMAGE_03 =
  "https://assets.turnoclub.com/developer/offer-turno-images/S3/WhyTurno/ElectricCommercialGoodsIcons/icon-09.webp";
export const ICON_IMAGE_04 =
  "https://assets.turnoclub.com/developer/offer-turno-images/S3/WhyTurno/ElectricCommercialGoodsIcons/icon-05.webp";

export const PROMISE_TITLE_01 = "100% Guaranteed Loan";
export const PROMISE_TITLE_02 = "Vehicle Delivery in 48 Hours";
export const PROMISE_TITLE_03 = "Lowest Prices";
export const PROMISE_TITLE_04 = "Documentation at Home";

export const META_TITLE =
  "Buy battery auto rickshaw from Turno. Best rickshaw price.";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Get exclusive offers and discounts on e rickshaw. Get Guaranteed financing, test drive at home and more. Click now",
  },
  {
    name: "keywords",
    content:
      "e rickshaw price,auto rickshaw,e rickshaw,rickshaw price,electric vehicle,battery rickshaw,e rickshaw price 2026,electric rickshaw,battery auto,three wheeler auto rickshaw,electric three wheeler,electric auto price,e rickshaw auto,electric auto,e rickshaw uttar pradesh price,e rickshaw buy,all fine e rickshaw,e rickshaw price",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/enquiry/electric-passenger",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/enquiry/electric-passenger",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Buy battery auto rickshaw from Turno. Best rickshaw price.",
  },
  {
    property: "og:description",
    content:
      "Get exclusive offers and discounts on e rickshaw. Get Guaranteed financing, test drive at home and more. Click now",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:title",
    content: "Buy battery auto rickshaw from Turno. Best rickshaw price.",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/enquiry/electric-passenger",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const FAQ_HEADER_TEXT =
  "Frequently Asked Questions on Battery Rickshaws";
